import { Component } from '@angular/core';

/**
 * The roleLandingGuard always redirects before this component renders. It is
 * intentionally empty and exists only to give the guarded landing route a
 * concrete route target.
 */
@Component({
  selector: 'app-role-landing-page',
  standalone: true,
  template: '',
})
export class RoleLandingPage {}
